import { combineReducers } from "redux";

import icons from "js/react/views/icons/reducers/iconsReducers";
// import {commonReducer} from "js/react/views/old/common/reducer";

export const reducers = () => {
    return combineReducers({
        // Add reducers here
        icons: icons(),
        // commonReducer,
    });
};

export default reducers;
